import Axios from "axios";

const state = {
    isCatalogueSearchHide: false,
    catalogueSearchMode: null
};

const getters = {
    isCatalogueSearchHide: state => state.isCatalogueSearchHide,
    catalogueSearchMode: state => state.catalogueSearchMode
};

const mutations = {
    setCatalogueSearchHidden: (state, data) => state.isCatalogueSearchHide = data,
    setCatalogueSearchMode: (state, data) => state.catalogueSearchMode = data
};

const actions = {
    searchType: (context, data) => {
        return Axios.post((<any>window).App.routes.CatalogueGlobalCarSearch_SearchType, data);
    },
    searchCode: (context, data) => {
        return Axios.post((<any>window).App.routes.CatalogueGlobalCarSearch_SearchCode, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};